import React, { Component } from 'react'
import ProcessingFeeUI from './ProcessingFeeUI.js'

class ProcessingFeeSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      procFeeMode: false,
      processingFeeMode: false,
      selectedPart: null,
      feeAmount: null
    }
  }

  render() {
    return (
      <ProcessingFeeUI
        context={this.props.context}
        errorList={this.props.errorList}
        loan={this.props.loan}
        onRefreshClick={this.props.onRefreshClick}

        pFStatusUpdated={this.props.pFStatusUpdated}
        onPFStatusUpdateClick={this.props.onPFStatusUpdateClick}
        onPFStatusCancelClick={this.props.onPFStatusCancelClick}
        pF2StatusUpdated={this.props.pF2StatusUpdated}
        onPF2StatusUpdateClick={this.props.onPF2StatusUpdateClick}
        onPF2StatusCancelClick={this.props.onPF2StatusCancelClick}
        //
        onProcFeeClick={this.onProcFeeClick}
        procFeeMode={this.state.procFeeMode}
        selectedPart={this.state.selectedPart}
        feeAmount={this.state.feeAmount}
        onProcFeeCancel={() => { this.setState({ procFeeMode: false }) }}
        //
        processingFeeMode={this.state.processingFeeMode}
        onProcessingFeeClick={() => { this.setState({ processingFeeMode: true }) }}
        onProcessingFeeCancel={() => { this.setState({ processingFeeMode: false }) }}
        //
        onUploadTDSClick1={this.props.onUploadTDSClick1}
        onUploadTDSClick2={this.props.onUploadTDSClick2}
        onUploadTDSCancelClick={this.props.onUploadTDSCancelClick}
        uploadTDSErrorList1={this.props.uploadTDSErrorList1}
        uploadTDSMode1={this.props.uploadTDSMode1}
        onUploadTDSUpload1={this.props.onUploadTDSUpload1}
        uploadTDSErrorList2={this.props.uploadTDSErrorList2}
        uploadTDSMode2={this.props.uploadTDSMode2}
        onUploadTDSUpload2={this.props.onUploadTDSUpload2}
        onDownloadClick1={this.props.onDownloadClick1}
        onDownloadClick2={this.props.onDownloadClick2}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
  }

  onProcFeeClick = (event) => {
    if (this.state.procFeeMode) return

    const selectedPart = event.currentTarget.getAttribute('data-row-id')
    const ts = this.props.loan.termSheet

    const feeAmount =
      selectedPart === '1'
        ? ts.processingFee1.amountWithTaxF1
        : ts.processingFee2.amountWithTaxF1

    this.setState({
      procFeeMode: true,
      selectedPart,
      feeAmount
    })
  }

}

export default ProcessingFeeSF


